import LinkBar from './LinkBar';

export default LinkBar;